{
  "title": "Wrack 'n Crack",
  "year": "2069",
  "logline": "America's favorite lethal game show. An OmniGrunt production.",
  "paragraphs": [
    "Governments became customer-service desks for mega-corps. Wars were bad for quarterly earnings. The corps picked something more efficient: televised attrition.",
    "You are an Opportunity Seeker. Clear arenas, grab cash and toys, and try not to become a Content Conclusion. Hope is marketing. The Host never stops smiling."
  ],
  "statusLine": "PC game · Godot · Level 1 playable offline · not in this browser",
  "footerNote": "Poster on the wall. Game on a real machine. Lore site later."
}
